// @flow

const numbersHaveChanged = (a, b) => {
  if (Number.isNaN(a) && Number.isNaN(b)) {
    return false;
  }

  return a !== b;
};

export default numbersHaveChanged;
